export const VIPRO_PATH = "https://vipro.studio";
export const VIPRO_ADVERTISEMENT_CTA_MESSAGE = {
  vi: "Tạo Video AI",
  en: "Create AI Video",
};
export const VIPRO_ADVERTISEMENT_FREQUENCY = 10;
export const VIPRO_ADVERTISEMENT_COUNTDOWN = 15;
